import { Col, CurrencyInput, Row } from '@paypalcorp/pp-react'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { interpolate } from 'ppbl/utils/string-helper'
import React, { useContext, useState } from 'react'
import { toCommaSeparatedNumber } from '../__utils__'
import { OfferContext } from './offerContext'
import { merge } from 'lodash-es'
import { trackClick } from 'ppbl/utils/fpti-helper'

/**
 * This is a functional component that takes input of desired loan amount
 * it also validates input against min and max pffer amount limiy
 * @returns {JSX.Element} - A JSX element
 */
const OfferInput: React.FC = () => {
  const {
    loanAmount,
    updateLoanAmount,
    offerMaxAmount,
    offerMinAmount,
    disableContinue,
    fptiData,
    applicationId,
  } = useContext(OfferContext)
  const [inputError, setInputError] = useState(false)
  const offerInputHelperText = interpolate(
    getLocalizedText('offer-page.offerInput.offerInputHelperText'),
    {
      minAmount: toCommaSeparatedNumber(offerMinAmount),
      maxAmount: toCommaSeparatedNumber(offerMaxAmount),
    },
  )

  // checks the validity of input box
  const isValidInput = (inputValue) => {
    if (
      Number(inputValue) >= Number(offerMinAmount) &&
      Number(inputValue) <= Number(offerMaxAmount)
    ) {
      return true
    }
    return false
  }

  const handleTrackInput = (event) => {
    if (Number(loanAmount) > Number(offerMaxAmount)) {
      updateLoanAmount(String(offerMaxAmount))
    } else if (Number(loanAmount) < Number(offerMinAmount)) {
      updateLoanAmount(String(offerMinAmount))
    }
    trackClick(
      merge(fptiData, {
        component: `offerInput_V1_${event.target.value}`,
        link: `offerInput_V1_${event.target.value}`,
        applicationId,
      }),
    )
  }

  /**
   * This function is triggered on user input and validats the unmasked input
   * throws error if the value is out of bound else sets input
   */

  const handleAccept = (
    _value: string,
    unmaskedValue: string,
    _typedValue: string,
  ) => {
    const validInput = isValidInput(unmaskedValue)
    setInputError(!validInput)
    disableContinue(!validInput)
    updateLoanAmount(unmaskedValue)
  }

  return (
    <div className="offerInputContainer">
      <Row>
        <Col xs={{ span: 12 }}>
          <CurrencyInput
            name="offer-amount-input"
            label={getLocalizedText('offer-page.offerInput.headerText')}
            onAccept={handleAccept}
            onBlur={handleTrackInput}
            value={loanAmount}
            helperText={offerInputHelperText}
            errorText={
              inputError &&
              interpolate(
                getLocalizedText('offer-page.offerInput.inputErrorText'),
                {
                  offerInputHelperText,
                },
              )
            }
            maskOptions={{
              mask: '$ num',
              blocks: {
                num: {
                  mask: Number,
                  thousandsSeparator: ',',
                  padFractionalZeros: false,
                },
              },
              lazy: false,
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default OfferInput
